import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './FootPrintApiManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_footprint_generic_json_order_export_dataService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { shipmentId?: number, orderId?: number }): Promise<{ DatexOrderInfo?: $types.FootPrintApiManager.DatexOrderInfo, orderId?: number }> 
  {
    let url = `${environment.backendUrl}api/FootPrintApiManager/functions/footprint_generic_json_order_export_data`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

